import script from "./ExhibitList.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitList.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitList.vue?vue&type=style&index=0&id=560f494a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-560f494a"]])

export default __exports__